import TextField from "@mui/material/TextField";
import {MenuItem, Select, Stack} from "@mui/material";
import * as React from "react";
import {COMMON_PREFERENCE_TYPES, Preference} from "crqlar-react-common/dist/models/profile/preference.model";
import Property from "crqlar-react-common/dist/components/Property";
import {useTranslation} from "react-i18next";

interface Props {
    id?: string;
    value?: Preference;
    onChange?: (preference?: Preference) => void;
    disabled?: boolean;
    index: number;
}

const PreferencesField = (props: Props) => {

    const {t} = useTranslation()
    const updateField = (field: keyof Preference, value: any) => {
        props.onChange?.({...props.value, [field]: value})
    }

    return (
        <Stack gap={1} id={props.id} width={'100%'}>
            <Property title={t('Type')} labelAlignment={'top'}>
                <Select
                    id={`preference-type-${props.index}`}
                    data-testid={`preference-type-${props.index}`}
                    value={props.value?.preferenceType}
                    onChange={(e) => updateField('preferenceType', e.target.value)}
                    fullWidth
                    size={'small'}
                    disabled={props.disabled}
                >
                    {
                        Object.values(COMMON_PREFERENCE_TYPES).map((type, index) => (
                            <MenuItem
                                key={index}
                                value={type}
                                id={`phone-type-${type}`}
                            >
                                {type ? t(`Common preference type ${type}`) : t('(Not set)')}
                            </MenuItem>
                        ))
                    }

                    {
                        /* If the active value is not in COMMON_PREFERENCE_TYPES, add it as one more item */
                        props.value?.preferenceType && !Object.values(COMMON_PREFERENCE_TYPES).map(v => v.toString()).includes(props.value?.preferenceType) &&
                        <MenuItem
                            key={'other'}
                            value={props.value?.preferenceType}
                            id={`phone-type-${props.value?.preferenceType}`}
                        >
                            {props.value?.preferenceType}
                        </MenuItem>
                    }

                </Select>
            </Property>

            <Property title={t('Preference')} labelAlignment={'top'}>
                <TextField
                    id={`preference-${props.index}`}
                    data-testid={`preference-${props.index}`}
                    value={props.value?.preferenceValue}
                    onChange={(e) => updateField('preferenceValue', e.target.value)}
                    fullWidth
                    size={'small'}
                    disabled={props.disabled}
                />
            </Property>

            <Property title={t('Other preference')} labelAlignment={'top'}>
                <TextField
                    id={`other-preference-${props.index}`}
                    data-testid={`other-preference-${props.index}`}
                    value={props.value?.otherPreferenceType}
                    onChange={(e) => updateField('otherPreferenceType', e.target.value)}
                    fullWidth
                    size={'small'}
                    disabled={props.disabled}
                />
            </Property>

        </Stack>
    )
}

export default PreferencesField;
